rAF = window.requestAnimationFrame or
      window.webkitRequestAnimationFrame or
      window.mozRequestAnimationFrame or
      window.oRequestAnimationFrame or
      window.msRequestAnimationFrame or
      (callback) -> window.setTimeout(callback, 1000 / 60)

module.exports =
  (func, duration = 300) ->
    timestamp = Date.now()
    isActive  = true

    do repeat = ->
      return unless isActive
      diff = Math.min(Date.now() - timestamp, duration)
      if diff < duration
        func diff / duration
        rAF(repeat)
      else
        func 1, true

    cancel: -> isActive = false
